import type { FormRule } from 'antd'
import { CLINIC, MEDIA, CLINIC_TYPE, NET, OTHER } from '../enum'
import { hideInsurantName, judgePhone, judgeCard } from '../../utils'
import { constant } from 'lodash-es'

export interface FormItemtype {
  title: string
  schema: schemaType[]
}

export type schemaType = {
  label: string
  type: string
  filed: string
  rules?: FormRule[] | ((item: any, options?: any[]) => FormRule[] | undefined)
  props?: Record<string, unknown> | ((item: any, options?: any[]) => Record<string, unknown>)
  tipsText?: string | ((item: any, options?: any[]) => string | null)
  className?: string
  showFiled?: string
  span?: number
  labelCol?: Record<string, unknown>
  format?: (val: any) => any
  render?: (item: any, options?: any[]) => string
}

export const formSchemaData: FormItemtype[] = [
  {
    title: '机构基础信息',
    schema: [
      {
        label: '医疗机构第一名称',
        rules: [{ required: true, message: '医疗机构第一名称不能为空' }],
        type: 'input',
        filed: 'orgName',
        tipsText: '参照医疗机构执业许可证正本机构名称填写',
      },
      {
        label: '发证卫生行政部门',
        rules: [{ required: true, message: '发证卫生行政部门不能为空' }],
        type: 'input',
        filed: 'department',
        tipsText: '参照医疗机构执业许可证正本发证部门填写',
      },
      {
        label: '《医疗机构执业许可证》登记号',
        className: 'yl_label',
        rules: [{ required: true, message: '登记号不能为空' }],
        type: 'input-registerBn',
        filed: 'registerBn',
        // span: 24,
        // labelCol: {
        //     span: 4
        // },
        tipsText: '参照医疗机构执业许可证正本登记号填写',
      },
      {
        label: '法人名称',
        rules: [
          { required: true, message: '法人名称不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{1,16}$'),
            message: '请输入正确的名称',
          },
        ],
        type: 'input',
        filed: 'legalPerson',
        tipsText: '参照医疗机构执业许可证正本法定代表人填写，若没有填"无"',
        showFiled: 'show_legalPerson',
        format: (value) => hideInsurantName(value),
      },

      {
        label: '主要负责人',
        rules: [
          { required: true, message: '主要负责人不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{1,16}$'),
            message: '请输入正确的名称',
          },
        ],
        type: 'input',
        filed: 'principal',
        tipsText: '参照医疗机构执业许可证正本法定代表人填写，若没有填"无',
        showFiled: 'show_principal',
        format: (value) => hideInsurantName(value),
      },
      {
        label: '身份证号',
        rules: [
          { required: true, message: '身份证号不能为空' },
          {
            pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
            message: '身份证号错误',
          },
        ],
        type: 'input',
        filed: 'idCard',
        showFiled: 'show_idCard',
        format: (value) => judgeCard(value),
        tipsText: '填法人代表或主要负责人身份证号',
      },
      {
        label: '医疗机构地址',
        rules: [{ required: true, message: '医疗机构地址不能为空' }],
        type: 'input',
        filed: 'address',
        span: 24,
        labelCol: {
          span: 4,
        },
        tipsText: '参照医疗机构执业许可证正本机构地址填写',
      },
      {
        label: '所有制形式',
        rules: [{ required: true, message: '所有形式不能为空' }],
        type: 'input',
        filed: 'ownership',
        // props: {
        //     options: (options: any[]) => {
        //         const data = options.filter(({ type }) => type === 'ownership');
        //         return data.map(({ name, dictBn }) => ({
        //             label: name,
        //             value: dictBn
        //         }));
        //     }
        // },
        tipsText: '参照医疗机构执业许可证副本所有制形式信息填写',
      },
      {
        label: '医疗机构类别',
        rules: [{ required: true, message: '医疗机构类别不能为空' }],
        type: 'select-search',
        filed: 'category_wj',
        // span: 7,
        // labelCol: {
        //     span: 10
        // },
        props: {
          options: (options: any[]) => {
            const data = options.filter(({ type }) => type === 'category_wj')
            return data.map(({ name, dictBn }) => ({
              label: `${name}（${dictBn}）`,
              value: dictBn,
            }))
          },
        },
        tipsText: '参照执业许可证登记号、备案证备案编号后五位填写',
      },
      // {
      //     label: '医疗机构类别代码',
      //     type: 'custom',
      //     filed: 'ylcode',
      //     span: 5,
      //     labelCol: {
      //         span: 15
      //     },
      //     render: (item, options = []) => {
      //         // const [opt = {}] = options.filter(({ dictBn }) => item?.category_wj === dictBn);
      //         return item?.category_wj || '';
      //     }
      // },
      {
        label: '校验有效期限',
        // rules: (item) => {
        //     // const [opt = {}] = options.filter(({ dictBn }) => item?.category_wj === dictBn);
        //     return CLINIC_TYPE.includes(item?.category_wj)
        //         ? undefined
        //         : [
        //               { required: true, message: '校验有效期限不能为空' },
        //               () => ({
        //                   validator(_, value) {
        //                       const test =
        //                           value.filter((val: any) => !!val).length === value.length;
        //                       return test
        //                           ? Promise.resolve()
        //                           : Promise.reject(new Error('校验有效期限不能为空'));
        //                   }
        //               })
        //           ];
        // },
        props: (item) => {
          return {
            disabled: CLINIC_TYPE.includes(item?.category_wj),
          }
        },
        type: 'range',
        filed: 'validDate',
        span: 24,
        labelCol: { span: 4 },
        tipsText:
          '各医院和门诊部校验有效期参照医疗机构执业许可证副本中校验记录信息填写，100张床位及以上校验期为三年，100张床位以下校验期为一年，若未开展校验则不填',
      },
      {
        label: '诊疗科目',
        rules: [
          { required: true, message: '诊疗科目不能为空' },
          // {
          //     pattern: new RegExp('^[a-zA-Z/\u4e00-\u9fa5;；、()（）*]+$'),
          //     message: '只能包含中英文 | 斜杠 | ; | 、| ( ) | *'
          // }
        ],
        type: 'text',
        filed: 'subject',
        span: 24,
        labelCol: {
          span: 4,
        },
        props: {
          placeholder: '格式要求：内科/外科/xxx',
        },
        tipsText: '参照医疗机构执业许可证正本诊疗科目信息填写',
      },
      {
        label: '床位数',
        type: 'number',
        filed: 'bed',
        tipsText: (item, options = []) => {
          // const [opt = {}] = options.filter(({ dictBn }) => item?.category_wj === dictBn);
          return CLINIC.includes(item?.category_wj) ? null : '参照医疗机构执业许可证副本床位数信息填写'
        },
        rules: (item, options = []) => {
          // const [opt = {}] = options.filter(({ dictBn }) => item?.category_wj === dictBn);
          return CLINIC.includes(item?.category_wj) ? undefined : [{ required: true, message: '床位数不能为空' }]
        },
        props: (item, options = []) => {
          // const [opt = {}] = options.filter(({ dictBn }) => item?.category_wj === dictBn);
          return {
            disabled: CLINIC.includes(item?.category_wj),
          }
        },
      },
      {
        label: '接诊时间',
        type: 'time',
        filed: 'receptionTime',
        tipsText: '根据实际情况填写',
        props: {
          format: 'HH:mm',
        },
        rules: [
          { required: true, message: '接诊时间不能为空' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              const isFilter = value ? value.filter((val: string) => !!val).length === 2 : false
              if (isFilter) return Promise.resolve()
              return Promise.reject(new Error('接诊时间不能为空'))
            },
          }),
        ],
      },
      {
        label: '申请属地',
        rules: [{ required: true, message: '申请属地不能为空' }],
        type: 'select',
        filed: 'area',
        props: {
          options: (options: any[]) => {
            const data = options.filter(({ type }) => type === 'area')
            return data.map(({ name, dictBn }) => ({
              label: name,
              value: dictBn,
            }))
          },
        },
      },
      {
        label: '医疗机构性质',
        rules: [{ required: true, message: '医疗机构性质不能为空' }],
        type: 'select',
        filed: 'orgProperty',
        props: {
          options: (options: any[]) => {
            const data = options.filter(({ type }) => type === 'org_property')
            return data.map(({ name, dictBn }) => ({
              label: name,
              value: dictBn,
            }))
          },
        },
      },
      {
        label: '联系电话',
        type: 'input',
        filed: 'phone',
        rules: [
          { required: true, message: '联系电话不能为空' },
          {
            pattern: new RegExp(/(^1\d{10}$|^(0\d{2,3}-?|0\d2,3)?[1-9]\d{4,7}(-\d{1,8})?$)/),
            message: '请输入正确的电话号码',
          },
        ],
        showFiled: 'show_phone',
        format: (value) => judgePhone(value),
      },
      {
        label: '邮编',
        type: 'input',
        filed: 'zipCode',
      },
      {
        label: '统一信用代码',
        rules: [
          { required: true, message: '统一信用代码不能为空' },
          {
            pattern: new RegExp(/^.{18}$/),
            message: '请输入正确的统一信用代码',
          },
        ],
        type: 'input',
        filed: 'uniformCreditCode',
      },
    ],
  },
  {
    title: '申请信息',
    schema: [
      {
        label: '发布媒体类别',
        rules: [{ required: true, message: '媒体类别不能为空' }],
        type: 'select',
        filed: 'media',
        props: {
          allowClear: true,
          showArrow: true,
          mode: 'multiple',
          options: (options: any[]) => {
            const data = options.filter(({ type }) => type === 'media')
            return data.map(({ name, dictBn }) => ({
              label: name,
              value: dictBn,
            }))
          },
        },
      },
      {
        label: '广告时长',
        type: 'input',
        filed: 'adDuration',
        tipsText: '参考填写样式：影视：10s；广播：5s。',
        rules: (item) => {
          if (!item?.media || !item?.media?.length) return undefined
          const values = item.media.filter((value: string) => MEDIA.includes(value))
          return values.length ? [{ required: true, message: '广告时长不能为空' }] : undefined
        },
      },
      //   {
      //     label: '网络发布平台',
      //     rules: (item) => {
      //       if (!item?.media || !item?.media?.length) return undefined
      //       const values = item.media.filter((value: string) => value === NET)
      //       return values.length ? [{ required: true, message: '网络发布平台不能为空' }] : undefined
      //     },
      //     type: 'input',
      //     filed: 'publish',
      //     props: (item) => {
      //       if (!item.media || !item.media.length) return { disabled: true }
      //       const values = item.media.filter((value: string) => value === NET)
      //       return {
      //         disabled: values.length ? false : true,
      //       }
      //     },
      //   },
      {
        label: '其他发布平台',
        rules: (item) => {
          if (!item?.media || !item?.media?.length) return undefined
          const values = item.media.filter((value: string) => value === OTHER)
          return values.length ? [{ required: true, message: '其他发布平台不能为空' }] : undefined
        },
        type: 'input',
        filed: 'other',
        props: (item) => {
          if (!item.media || !item.media.length) return { disabled: true }
          const values = item.media.filter((value: string) => value === OTHER)
          return {
            disabled: values.length ? false : true,
          }
        },
      },
      {
        label: '经办人',
        rules: [
          { required: true, message: '经办人不能为空' },
          {
            pattern: new RegExp('^[\u4e00-\u9fa5]{2,16}$'),
            message: '请输入正确的名称',
          },
        ],
        type: 'input',
        filed: 'contactName',
        showFiled: 'show_contactName',
        format: (value) => hideInsurantName(value),
      },
      {
        label: '经办人身份证号码',
        rules: [
          { required: true, message: '身份证号码不能为空' },
          {
            pattern: new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
            message: '身份证号错误',
          },
        ],
        type: 'input',
        filed: 'contactIdCard',
        showFiled: 'show_contactIdCard',
        format: (value) => judgeCard(value),
      },
      {
        label: '联系电话',
        rules: [
          { required: true, message: '联系电话不能为空' },
          {
            pattern: new RegExp(/(^1\d{10}$|^(0\d{2,3}-?|0\d2,3)?[1-9]\d{4,7}(-\d{1,8})?$)/),
            message: '请输入正确的电话号码',
          },
        ],
        type: 'input',
        filed: 'contactPhone',
        showFiled: 'show_contactPhone',
        format: (value) => judgePhone(value),
      },
      {
        label: '电子邮箱',
        rules: [
          { required: true, message: '电子邮箱不能为空' },
          {
            pattern: new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/),
            message: '邮箱格式错误',
          },
        ],
        type: 'input',
        filed: 'contactEmail',
      },
    ],
  },
]
